/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const BulkUserAction = {
    disable: 'disable',
    enable: 'enable',
    delete: 'delete',
    blacklist: 'blacklist',
    unblacklist: 'unblacklist'
} as const;
export type BulkUserAction = typeof BulkUserAction[keyof typeof BulkUserAction];


export function instanceOfBulkUserAction(value: any): boolean {
    for (const key in BulkUserAction) {
        if (Object.prototype.hasOwnProperty.call(BulkUserAction, key)) {
            if (BulkUserAction[key as keyof typeof BulkUserAction] === value) {
                return true;
            }
        }
    }
    return false;
}

export function BulkUserActionFromJSON(json: any): BulkUserAction {
    return BulkUserActionFromJSONTyped(json, false);
}

export function BulkUserActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUserAction {
    return json as BulkUserAction;
}

export function BulkUserActionToJSON(value?: BulkUserAction | null): any {
    return value as any;
}

export function BulkUserActionToJSONTyped(value: any, ignoreDiscriminator: boolean): BulkUserAction {
    return value as BulkUserAction;
}

